import { useEffect } from "react";
import {
  cleanupStaleModalArtifacts,
  hasStaleBootstrapModalArtifacts,
} from "utils/cleanupStaleModalArtifacts";

export default function useStaleModalArtifactCleanup() {
  useEffect(() => {
    if (typeof document === "undefined" || typeof MutationObserver === "undefined") {
      return undefined;
    }

    const scheduleIfStale = () => {
      if (hasStaleBootstrapModalArtifacts()) {
        cleanupStaleModalArtifacts();
      }
    };

    scheduleIfStale();
    const observer = new MutationObserver(scheduleIfStale);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);
}
